import {
    S as h
} from "./swiper-core-BxEZpPjz.js"; /* empty css               */
import {
    d as v
} from "./dayjs.min-BIwLhz4I.js";
import {
    c as N
} from "./couponbar-D0q7EcRI.js";
import "./category-slideshow-BT9xAyYB.js";
import "./linklist-B5L6JgIt.js";
import "./article-highlights-y3xkDxTN.js";
import "./myharray-block-DpHDJRei.js";
import "./function-boxes-aHoKc9lF.js";
import "./rating-block-large-Zm_fxinm.js";
import "./subcollections-slider-BUE0VG93.js";
import "./sort-filter-CTB7fn2x.js";
import "./cart-recomendations-d0Ue09Ke.js";
import "./quicklinks-Dj6Kcsp5.js";
import "./accounts-B-_b3C1j.js";
import "./latest-blog-posts-B4I-otf6.js";
import "./small-collection-list-u_f2xWfd.js";
import "./_commonjsHelpers-BosuxZz1.js";
v.extend(N);
const M = async o => {
    const i = o.getAttribute("data-product-id"),
        t = await fetch(`https://jmmyharry.corestad.com/api/reviews/sum?id=${i}`).then(m => m.json());
    if (!t) return;
    const e = t.avg_rating ? isNaN(t.avg_rating) ? 0 : t.avg_rating : 0,
        c = t.all_count,
        r = o.querySelector(".card__avg-rating"),
        a = o.querySelector(".card__all-rating");
    r && ((parseInt(e) > 0) ? r.innerHTML = e : r.classList.add('no-review')), a && (a.innerHTML = `(${c})`), Number(c) === 0 && o.querySelectorAll(".card__stars svg").forEach(f => {
        f.style.color = "#BCBEC066"
    }), o.classList.remove("card--not-initialized"), o.classList.add("card--initialized")
};
document.addEventListener("DOMContentLoaded", () => {
    const o = document.querySelector("#header-search-toggle-btn"),
        i = () => {
            const e = document.querySelector(".myharry-header__search--mobile");
            e == null || e.classList.add("myharry-header__search--hidden"), document.removeEventListener("scroll", i)
        },
        n = e => {
            e == null || e.classList.toggle("myharry-header__search--hidden")
        };
    o == null || o.addEventListener("click", () => {
        const e = document.querySelector(".myharry-header__search--mobile");
        e != null && e.classList.contains("myharry-header__search--hidden") && document.addEventListener("scroll", i), n(e)
    }), document.querySelectorAll("product-card.card--not-initialized").forEach(e => {
        M(e)
    }), setInterval(() => {
        document.querySelectorAll("product-card.card--not-initialized").forEach(c => {
            M(c)
        })
    }, 550)
});
document.addEventListener("DOMContentLoaded", () => {
    var i;
    const o = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, {
        acceptNode: n => NodeFilter.FILTER_ACCEPT
    });
    for (; o.nextNode();) {
        const n = o.currentNode,
            t = n.textContent;
        if (((i = n == null ? void 0 : n.children) == null ? void 0 : i.length) === 0 && (t != null && t.includes("[u]") || t != null && t.includes("[uu]"))) {
            const e = /\[u\](.*?)\[\/u\]/gi,
                c = /\[uu\](.*?)\[\/uu\]/gi;
            n.style.position = "relative", n.style["z-index"] = 1, n.innerHTML = n.innerHTML.replaceAll(e, '<span class="tw-primary-single-underline">$1</span>'), n.innerHTML = n.innerHTML.replaceAll(c, '<span class="tw-yellow-double-underline">$1</span>')
        }
    }
    document.querySelectorAll(".tw-yellow-double-underline").forEach(n => {
        n.getBoundingClientRect().width > 198 && n.classList.add("tw-yellow-double-underline--long")
    }), document.querySelectorAll(".tw-primary-single-underline").forEach(n => {
        n.getBoundingClientRect().width > 198 && n.classList.add("tw-primary-single-underline--long")
    })
});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".mega-menu summary").forEach(o => {
        o.addEventListener("click", ({
            target: i
        }) => {
            const n = o.parentElement;
            if (n && !n.hasAttribute("open")) {
                const t = n.querySelector(".mega-menu__content");
                if (!t) return;
                t.classList.add("!tw-opacity-0"), setTimeout(() => {
                    const e = n.getBoundingClientRect(),
                        c = t == null ? void 0 : t.getBoundingClientRect();
                    let a = e.x + e.width / 2 - c.width / 2;
                    a < 0 && (a = 0), a + c.width > window.innerWidth ? (t.style.left = "auto", t.style.right = "5rem") : t.style.left = `${a}px`, setTimeout(() => {
                        t.classList.remove("!tw-opacity-0")
                    }, 100)
                }, 100)
            }
        })
    })
});
document.addEventListener("DOMContentLoaded", () => {
    const o = document.querySelector(".tag-cloud__swiper.swiper");
    o && new h(o, {
        slidesPerView: "auto",
        spaceBetween: 10
    })
});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".shortcode-collection__swiper.swiper").forEach(i => {
        new h(i, {
            slidesPerView: "auto",
            spaceBetween: 16
        })
    })
});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".featured-collection-section .swiper").forEach(i => {
        var c, r;
        const n = new h(i, {
                slidesPerView: "auto",
                spaceBetween: 10,
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 15
                    },
                    1024: {
                        slidesPerView: "auto",
                        spaceBetween: 30
                    }
                }
            }),
            t = (c = i.closest(".featured-collection-section")) == null ? void 0 : c.querySelectorAll(".collection__navigation--next"),
            e = (r = i.closest(".featured-collection-section")) == null ? void 0 : r.querySelectorAll(".collection__navigation--prev");
        t.forEach(a => {
            a.addEventListener("click", () => {
                n.slideNext()
            })
        }), e.forEach(a => {
            a.addEventListener("click", () => {
                n.slidePrev()
            })
        })
    })
});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".product-showcase__swiper .swiper").forEach(i => {
        new h(i, {
            slidesPerView: "auto",
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 30
                }
            }
        })
    })
});
document.addEventListener("DOMContentLoaded", () => {
    [...document.querySelectorAll(".myharry-article-card.myharry-article-card--video")].forEach(i => {
        const n = i.querySelector(".myharry-article-card__image-holder--video"),
            t = i.querySelector(".myharry-article-card__dialog");
        if (!t || !n) return;
        const e = t.querySelector(".myharry-article-card__video-holder"),
            c = e == null ? void 0 : e.querySelector("video");

        function r(l) {
            e != null && e.contains(l.target) || m()
        }

        function a() {
            var l;
            t.showModal(), (l = document.querySelector("body")) == null || l.classList.add("tw-overflow-hidden"), t.addEventListener("click", r)
        }

        function m() {
            var l;
            c.pause(), t.removeEventListener("click", r), t.close(), (l = document.querySelector("body")) == null || l.classList.remove("tw-overflow-hidden")
        }
        n.addEventListener("click", () => {
            a()
        }), t.querySelector(".myharry-article-card__video-close").addEventListener("click", () => {
            m()
        })
    })
});
document.addEventListener("ready", () => {
    const o = document.querySelector(".predictive-search.predictive-search--header");
    o == null || o.classList.remove("tw-hidden")
});
document.addEventListener("DOMContentLoaded", () => {
    const o = "favorite_products",
        i = ".product-favorite-button.product-favorite-button--uninitialized",
        t = c => {
            c.classList.remove("product-favorite-button--uninitialized");
            const r = c.getAttribute("data-product-id");
            if (!r) return;
            const a = localStorage.getItem(o);
            let m = [];
            a ? m = JSON.parse(a) : localStorage.setItem(o, JSON.stringify(m)), m.includes(r) && c.classList.add("product-favorite-button--active"), c.addEventListener("click", () => {
                const f = document.querySelectorAll(`.product-favorite-button[data-product-id="${r}"]`),
                    l = localStorage.getItem(o);
                if (l) {
                    const y = JSON.parse(l);
                    if (y.includes(r)) {
                        f.forEach(w => {
                            w.classList.remove("product-favorite-button--active")
                        });
                        const d = y.filter(w => w !== r);
                        localStorage.setItem(o, JSON.stringify(d))
                    } else f.forEach(d => {
                        d.classList.add("product-favorite-button--active")
                    }), y.push(r), localStorage.setItem(o, JSON.stringify(y))
                } else localStorage.setItem(o, JSON.stringify([r]))
            })
        },
        e = document.querySelectorAll(i);
    e == null || e.forEach(c => {
        t(c)
    }), setInterval(() => {
        const c = document.querySelectorAll(i);
        c == null || c.forEach(r => {
            t(r)
        })
    }, 400)
});
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".article-template__related-slider.swiper, .article-template__product-reviews-slider.swiper").forEach(i => {
        new h(i, {
            slidesPerView: "auto",
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 40
                }
            }
        })
    })
});
window.CRSTD_INIT_SWIPER = o => {
    document.querySelectorAll(o).forEach(n => {
        new h(n, {
            slidesPerView: "auto",
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 40
                }
            }
        })
    })
};
document.addEventListener("DOMContentLoaded", () => {
    const o = window.location.pathname;
    if (!o.includes("/tagged/")) return;
    const i = o.split("/").pop();
    document.querySelectorAll(".latest-blog__tag .article-tag").forEach(t => {
        var e;
        (e = t.getAttribute("data-handle")) != null && e.includes(i || "NOT_WHAT_LOOKING_FOR") && t.parentNode.classList.add("latest-blog__tag--active")
    })
});
document.addEventListener("DOMContentLoaded", () => {
    const o = document.querySelectorAll(".price-per-item__container--sqr-to-piece");
    window.CRSTD_PRODUCT_PAGE_SQR_TO_PIECE = [], o.forEach(i => {
        const n = i.querySelector(".quantity--square"),
            t = i.querySelector(".quantity--piece"),
            e = i.querySelector(".mh-qty-text"),
            c = i.querySelectorAll(".mh-qty-switch__label");
        
				if (!n || !t || !e || !c) return;
				
        c.forEach(s => {
            s.addEventListener("click", () => {
                s.classList.contains("mh-qty-switch__label--active") || (c.forEach(u => {
                    u.classList.toggle("mh-qty-switch__label--active")
                }), s.dataset.type === "squarem" ? (n.classList.remove("!tw-hidden"), e.classList.remove("!tw-hidden"), t.classList.add("!tw-hidden")) : (n.classList.add("!tw-hidden"), e.classList.add("!tw-hidden"), t.classList.remove("!tw-hidden")))
            })
        });
        const r = n.querySelector("input.quantity__input--square"),
            a = t.querySelector("input.quantity__input");
        n.querySelectorAll("button.quantity__button").forEach(s => {
            s.addEventListener("click", () => {
                const u = s.getAttribute("name"),
                    p = Number(r.dataset.numbValue);
                u === "minus" && p > 1 && (r.dataset.numbValue = `${p-1}`, r.value = `${p-1}m²`), u === "plus" && (r.dataset.numbValue = `${p+1}`, r.value = `${p+1}m²`), r.dispatchEvent(new Event("blur"))
            })
        }), t.querySelectorAll("button.quantity__button").forEach(s => {
            s.addEventListener("click", () => {
                a.dispatchEvent(new Event("blur"))
            })
        });
        let l = e.dataset.currencySymbol,
            y = Number(e.dataset.sqrmMultiplier),
            d = Number(e.dataset.price),
            w = Number(e.dataset.comparePrice);
        const L = () => {
                l = e.dataset.currencySymbol, y = Number(e.dataset.sqrmMultiplier), d = Number(e.dataset.price), w = Number(e.dataset.comparePrice)
            },
            _ = () => {
                L();
                const s = Number(a.value),
                    u = String(s * d / 100).replace(".", ",") + l,
                    p = String(s * w / 100).replace(".", ",") + l,
                    g = e.querySelector(".mh-qty-text__pieces-info"),
                    E = (g.dataset.template || "").replace("{{ pieces }}", String(s));
                g.innerHTML = E;
                const S = e.querySelector(".mh-qty-text__pieces-compare-price");
                S && (S.innerHTML = p);
                const A = e.querySelector(".mh-qty-text__price");
                A && (A.innerHTML = u)
            };
        r.addEventListener("blur", () => {
            const s = /^\d+/;
            let u = "";
            const p = r.value.match(s);
            p && p[0] && (u = p[0]), u ? (r.value = `${u}m²`, r.dataset.numbValue = u) : (r.value = "1m²", r.dataset.numbValue = "1");
            const g = Number(r.dataset.numbValue),
                q = Number(a.getAttribute("data-min")) || 1,
                E = Number(a.getAttribute("data-step")) || 1;
            let S = Math.ceil(g * y);
            S % E !== 0 && (S = Math.ceil(S / E) * E), a.value = String(Math.max(q, S)), _()
        });
        const b = () => {
            L();
            const s = new Event("blur");
            r.dispatchEvent(s)
        };
        window.CRSTD_PRODUCT_PAGE_SQR_TO_PIECE.push({
            reRenderSqrmText: b,
            updateInternalBaseNumericValues: L
        }), a.addEventListener("blur", () => {
            L();
            const s = Number(a.value),
                u = Number(a.getAttribute("data-step")) || 1;
            isNaN(s) ? a.value = a.getAttribute("data-min") || "1" : s % u !== 0 && (a.value = String(Math.ceil(s / u) * u));
            const p = Math.floor(s / y);
            r.value = `${p}m²`, r.dataset.numbValue = String(p), _()
        }), b()
    })
});
window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".product-page__qtty-input").forEach(n => {
        const t = Number(n.getAttribute("step")),
            e = Number(n.getAttribute("min"));
        n.addEventListener("blur", () => {
            window.CRSTD_PRODUCT_PAGE_SQR_TO_PIECE.forEach(({
                updateInternalBaseNumericValues: r
            }) => r ? r() : null);
            let c = Number(n.value);
            c < e ? n.value = e.toString() : n.value = String(Math.round(c / t) * t)
        })
    })
});
window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".crstd-variant-dropdown").forEach(n => {
        const t = n.querySelector("select");
        if (!t) return;
        const e = n.getAttribute("data-id");
        if (!e) return;
        const c = document.querySelector(`[data-id="${e}"]`);
        c && t.addEventListener("change", r => {
            var f;
            r.stopPropagation();
            const a = (f = r.target) == null ? void 0 : f.value,
                m = c.querySelectorAll("input");
            for (const l of m)
                if (l.value === a) {
                    const y = l.getAttribute("id"),
                        d = c.querySelector(`label[for="${y}"]`);
                    d == null || d.click();
                    break
                }
        })
    })
});
window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-timer").forEach(i => {
        i.getAttribute("data-section-id");
        const n = i.getAttribute("data-enddate"),
            t = i.getAttribute("data-code"),
            e = v(n, "DD/MM/YYYY HH:mm");
        if (!e.isValid() || e.isBefore(v())) return;
        const c = i.querySelector(".countdown__timer");
        if (c) {
            let f;
            const l = () => {
                if (e.diff(v()) <= 0) {
                    c.innerHTML = "00:00:00:00", f && clearInterval(f);
                    return
                }
                let d = "";
                d += e.diff(v(), "days").toString().padStart(2, "0"), d += ":", d += String(e.diff(v(), "hours") % 24).padStart(2, "0"), d += ":", d += String(e.diff(v(), "minutes") % 60).padStart(2, "0"), d += ":", d += String(e.diff(v(), "seconds") % 60).padStart(2, "0"), c.innerHTML = d
            };
            l(), f = setInterval(l, 1e3)
        }
        const r = i.querySelector(".countdown__btn--action"),
            a = i.querySelector(".countdown__btn--check");
        if (!r || !a || !t) return;
        const m = () => {
            navigator.clipboard.writeText(t), r.classList.add("tw-hidden"), r.classList.remove("tw-flex"), a.classList.add("tw-flex"), a.classList.remove("tw-hidden"), setTimeout(() => {
                a.classList.add("tw-hidden"), a.classList.remove("tw-flex"), r.classList.remove("tw-hidden"), r.classList.add("tw-flex")
            }, 1500)
        };
        r.addEventListener("click", m)
    })
});